import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
/**** Store Global - Variables Globales */
import { Provider } from "react-redux";
import store from "./store";
import { SnackbarProvider } from "notistack";
/**  Fechas*/
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import esLocale from "date-fns/locale/es";
//
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#0097a7",
    },
    secondary: {
      main: "#e65100",
    },
    background: {
      default: "#F2F2F2",
      paper: "#fff",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={esLocale}
      >
        <BrowserRouter>
          <Provider store={store}>
            <SnackbarProvider maxSnack={3} autoHideDuration={4000}>
              <CssBaseline />
              <App />
            </SnackbarProvider>
          </Provider>
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);
